module.exports = __webpack_public_path__ + "static/media/Colette King Bed Base - 180x210 cm_Dark Blue.98be92a2.png";